import { render, staticRenderFns } from "./ChatRecodSearchComp.vue?vue&type=template&id=47c29ea4&"
import script from "./ChatRecodSearchComp.vue?vue&type=script&lang=js&"
export * from "./ChatRecodSearchComp.vue?vue&type=script&lang=js&"
import style0 from "./ChatRecodSearchComp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports